import { z } from 'zod';

export enum ValidationEntryResultScopeType {
    DATA_DICTIONARY_VERSION = 'DATA_DICTIONARY_VERSION',
    DATA_DICTIONARY_VARIANT = 'DATA_DICTIONARY_VARIANT',
    DATA_DICTIONARY_VALUE_SET = 'DATA_DICTIONARY_VALUE_SET',
    PROJECT_LINE_VERSION = 'PROJECT_LINE_VERSION',
    ANY_SCOPE = 'ANY_SCOPE',
}

export const ValidationEntryResultScopeTypeSchema = z.enum(ValidationEntryResultScopeType);
